import { useState } from "react";
import "./App.css";
import { Routes, Route, Link, useNavigate } from "react-router-dom";
import Detail from "./detail/Detail";
import { useRecoilState } from "recoil";
import {
  likeImgState,
  likeState,
  loadingBarState,
  totalLikeState,
} from "./store";
import LoadingBar from "./components/LoadingBar";
import { useSetRecoilState } from "recoil";

const data = [
  {
    id: 1,
    profile: "Mario",
    title: "nintendo product no.1",
    content:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum",
    like: 0,
    comments: [],
  },
  {
    id: 2,
    profile: "Zelda",
    title: "nintendo product no.2",
    content:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum",
    like: 0,
    comments: [],
  },
  {
    id: 3,
    profile: "Pokemon",
    title: "nintendo product no.3",
    content:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum",
    like: 0,
    comments: [],
  },
];

function App() {
  /* 토탈Like에 관한 state */
  // const [totalLike, setTotalLike] = useState(0);
  const [totalLike, setTotalLike] = useRecoilState(totalLikeState);

  /* 스크롤에 관한 state */
  const [mainScroll, setMainScroll] = useState(false);

  /* 토탈Like에 관한 Handle */
  const handleLikeUp = () => {
    setTotalLike(totalLike + 1);
  };
  const handleLikeDown = () => {
    setTotalLike(totalLike - 1);
  };

  /* 스크롤에 관한 Handle */
  const handleScroll = (e) => {
    if (!mainScroll) {
      setTimeout(() => {
        setMainScroll(true);
        document.querySelector("html").style.overflow = "hidden";
      }, 1000); // 로딩바가 끝난 후에 실행
    } else {
      setMainScroll(false);
      document.querySelector("html").style.overflow = "visible";
    }
  };

  const [loading, setLoading] = useRecoilState(loadingBarState);

  return (
    <div className="App flex">
      <header className="App-header flex-none w-[280px]">
        <div className="fixed w-[280px] p-3 h-full border-r border-gray-300 border-solid flex flex-col justify-between ">
          <div>
            <img
              src={`${process.env.PUBLIC_URL}/logo.svg`}
              className="App-logo w-[103px] m-3 mb-6"
              alt="logo"
            />
            <ul>
              <li className="p-3 hover:bg-slate-100 rounded-xl">
                <a className="flex items-center" href="/">
                  <img src={`${process.env.PUBLIC_URL}/icon01.svg`} alt="" />
                  <h4 className="pl-4">홈</h4>
                </a>
              </li>
              <li className="p-3 hover:bg-slate-100 rounded-xl">
                <a className="flex items-center" href="/">
                  <img src={`${process.env.PUBLIC_URL}/icon02.svg`} alt="" />
                  <h4 className="pl-4">로고크기 103px</h4>
                </a>
              </li>
              <li className="p-3 hover:bg-slate-100 rounded-xl">
                <a className="flex items-center" href="/">
                  <img src={`${process.env.PUBLIC_URL}/icon03.svg`} alt="" />
                  <h4 className="pl-4">너비값 280px</h4>
                </a>
              </li>
              <li className="p-3 hover:bg-slate-100 rounded-xl">
                <a className="flex items-center" href="/">
                  <img src={`${process.env.PUBLIC_URL}/icon04.svg`} alt="" />
                  <h4 className="pl-4">모든패딩 12px</h4>
                </a>
              </li>
              <li className="p-3 hover:bg-slate-100 rounded-xl">
                <a className="flex items-center" href="/">
                  <img src={`${process.env.PUBLIC_URL}/icon05.svg`} alt="" />
                  <h4 className="pl-4">호버시 241 245 249</h4>
                </a>
              </li>
              <li className="p-3 hover:bg-slate-100 rounded-xl">
                <a className="flex items-center relative" href="/">
                  <img src={`${process.env.PUBLIC_URL}/icon06.svg`} alt="" />
                  <span
                    className={`rounded-full absolute bg-[#ff3040] text-white h-[18px] leading-[18px] px-1.5 text-[11px] left-4 -top-1 ${
                      totalLike === 0 ? "opacity-0" : "opacity-1"
                    }`}
                  >
                    {totalLike}
                  </span>
                  <h4 className="pl-4">알림</h4>
                </a>
              </li>
              <li className="p-3 hover:bg-slate-100 rounded-xl">
                <a className="flex items-center" href="/">
                  <img src={`${process.env.PUBLIC_URL}/icon07.svg`} alt="" />
                  <h4 className="pl-4">만들기</h4>
                </a>
              </li>
            </ul>
          </div>

          <div className="p-3 hover:bg-slate-100 rounded-xl">
            <a className="flex items-center" href="/">
              <img src={`${process.env.PUBLIC_URL}/icon09.svg`} alt="" />
              <h4 className="pl-4">더 보기</h4>
            </a>
          </div>
        </div>
      </header>
      <Card
        handleLikeUp={handleLikeUp}
        handleLikeDown={handleLikeDown}
        handleScroll={handleScroll}
      />
      <LoadingBar />
      <Routes>
        <Route
          path="/detail/:id"
          element={
            !loading && mainScroll ? (
              <>
                <Detail
                  data={data}
                  handleScroll={handleScroll}
                  handleLikeUp={handleLikeUp}
                  handleLikeDown={handleLikeDown}
                />
              </>
            ) : null
          }
        />
      </Routes>
    </div>
  );
}

function Card(props) {
  const [like, setLike] = useRecoilState(likeState);
  const [likeimg, setLikeimg] = useRecoilState(likeImgState);

  const setLoading = useSetRecoilState(loadingBarState);
  const navigate = useNavigate();

  const handleClick = (id) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate(`/detail/${id}`);
    }, 1000);
  };
  return (
    <>
      <section className="w-full">
        {data.map((v, i) => {
          return (
            <div className="w-[460px] mt-8 mb-14 mx-auto" key={i}>
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center">
                  <img
                    src={`${process.env.PUBLIC_URL}/profile${eval(i + 1)}.jpg`}
                    className="w-[32px] rounded-full"
                    alt=""
                  />
                  <p className="pl-3">{data[i].profile}</p>
                </div>
                <img src={`${process.env.PUBLIC_URL}/icon10.svg`} alt="" />
              </div>
              <Link
                to={`/detail/${i}`}
                onClick={() => {
                  props.handleScroll();
                  handleClick(i);
                }}
              >
                <div className="mb-3">
                  <img
                    src={`${process.env.PUBLIC_URL}/thumb${eval(i + 1)}.jpg`}
                    className="w-full"
                    alt=""
                  />
                </div>
              </Link>
              <div>
                <div className="mb-3">
                  <button
                    onClick={
                      like[i] === 0 ? props.handleLikeUp : props.handleLikeDown
                    }
                    className={
                      likeimg[i] === true
                        ? "hover:opacity-35"
                        : "hover:opacity-100"
                    }
                  >
                    <img
                      onClick={() => {
                        let copy1 = [...like];
                        likeimg[i] === true ? copy1[i]++ : copy1[i]--;
                        setLike(copy1);
                        let copy2 = [...likeimg];
                        copy2[i] = !copy2[i];
                        setLikeimg(copy2);
                      }}
                      src={
                        likeimg[i] === true
                          ? `${process.env.PUBLIC_URL}/icon11.svg`
                          : `${process.env.PUBLIC_URL}/icon12.svg`
                      }
                      alt=""
                    />
                  </button>
                </div>
                <div>
                  <p className="mb-3">
                    좋아요 <span>{like[i]}</span>개
                  </p>
                  <h4 className="mb-3">{data[i].title}</h4>
                  <p className="mb-3 text-base">{data[i].content}</p>
                </div>
                <div>
                  <input
                    className="w-full border-b border-solid border-gray-300 py-3"
                    placeholder="댓글달기"
                  ></input>
                </div>
              </div>
            </div>
          );
        })}
      </section>
    </>
  );
}

export default App;
